import "../pages/css/App.css";
import "../pages/css/WhiskyCreate.css";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../hooks/logout.js";
import { API_BASE_URL } from "../app_config.js";

const getAuthToken = () => localStorage.getItem("token");

function AssignWhisky() {
  const navigate = useNavigate();

  const [tastings, setTastings] = useState([]);
  const [whiskys, setWhiskys] = useState([]);

  const [tastingId, setTastingId] = useState("");
  const [whiskyId, setWhiskyId] = useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleBackToStart = () => {
    navigate("/main");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = getAuthToken();
        const tastingResponse = await fetch(`${API_BASE_URL}/api/tastingData`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const whiskyResponse = await fetch(`${API_BASE_URL}/api/whisky`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!tastingResponse.ok || !whiskyResponse.ok) {
          throw new Error("Fehler beim Laden der Daten");
        }

        const tastingData = await tastingResponse.json();
        const whiskyData = await whiskyResponse.json();

        setTastings(tastingData);
        setWhiskys(whiskyData);
      } catch (err) {
        console.error(err);
        setErrorMessage("Fehler beim Laden der Tastings oder Whiskys.");
      }
    };

    fetchData();
  }, []);

  const handleAssignWhisky = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setSuccessMessage("");

    if (!tastingId || !whiskyId) {
      setErrorMessage("Bitte Tasting und Whisky auswählen.");
      return;
    }

    const assignData = {
      tasting_id: parseInt(tastingId),
      whisky_id: parseInt(whiskyId),
    };

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_BASE_URL}/api/assignWhisky`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },

        body: JSON.stringify(assignData),
      });

      if (!response.ok) {
        const text = await response.text();
        console.error("Server Response:", text);

        throw new Error("Whisky konnte nicht zugewiesen werden.");
      }

      await response.json();

      setSuccessMessage("Whisky erfolgreich zum Tasting hinzugefügt.");
      setWhiskyId("");
      setTastingId("");
    } catch (err) {
      console.error(err);
      setErrorMessage(err.message);
    }
  };

  return (
    <div className="page-layout">
      <div className="menu-container">
        <div className="title-box">
          <p>Willkommen bei DRAM</p>
        </div>

        <div className="menu-box">
          <h1>Whisky zuordnen</h1>
        </div>

        <nav className="nav">
          <button className="nav-button" onClick={handleBackToStart}>
            Startseite
          </button>

          <button className="nav-button" type="submit" form="assignForm">
            Zuordnung speichern
          </button>

          <button className="nav-button" onClick={() => logout(navigate)}>
            Abmelden
          </button>
        </nav>

        <img
          src={require("../assets/logo.png")}
          alt="Versionsinformationen anzeigen"
          className="whisky-image"
          role="button"
          tabIndex={0}
        />
      </div>

      <div className="whisky-form-group">
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}

        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <form id="assignForm" onSubmit={handleAssignWhisky}>
          <label htmlFor="tasting">Tasting auswählen:</label>

          <select
            id="tasting"
            value={tastingId}
            onChange={(e) => setTastingId(e.target.value)}
            required
          >
            <option value="">Bitte wählen</option>

            {tastings.map((tasting) => (
              <option key={tasting.id} value={tasting.id}>
                {tasting.motto}
              </option>
            ))}
          </select>

          <label htmlFor="whisky">Whisky auswählen:</label>

          <select
            id="whisky"
            value={whiskyId}
            onChange={(e) => setWhiskyId(e.target.value)}
            required
          >
            <option value="">Bitte wählen</option>

            {whiskys.map((whisky) => (
              <option key={whisky.id} value={whisky.id}>
                {whisky.name} - (
                {whisky.alcohol_percent != null
                  ? Number(whisky.alcohol_percent).toFixed(1)
                  : "–"}
                %)
              </option>
            ))}
          </select>
        </form>
      </div>
    </div>
  );
}

export default AssignWhisky;
